/**
 * Determine if the content is Html or not
 *
 * @param content
 * @returns {boolean}
 */
export default function detectHtml(content) {
	return typeof content == 'string'
}
